import React, {Fragment} from 'react'

const Transactions = (props) => {
    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">لیست تراکنش ها</span>
                </div>
            </div>
            <span className="lineSeparator"></span>
            <div className="maximumSizeHandler">

                <div className="tableActions">
                    <div className="">
                    </div>
                    <div className="">
                        <div className="standardLink pdfColor leftMargin"><span className="icon icon-pdf"></span> دانلود
                            PDF لیست
                        </div>
                        <div className="standardLink excelColor"><span className="icon icon-excel"></span> دانلود Excel
                            لیست
                        </div>
                    </div>
                </div>
                <div className="tableContainer relative orderTable">
                    <div className="tableStructure">
                        <div className="headerLine"></div>
                    </div>
                    <div className="tableContent">
                        <div className="tableItem">
                            <div className="tableColumnItem">نام پلن</div>
                            <div className="tableColumnItem">رویداد کوچک
                            </div>
                            <div className="tableColumnItem">رویداد کوچک
                            </div>
                            <div className="tableColumnItem">رویداد کوچک
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">تاریخ پرداخت</div>
                            <div className="tableColumnItem">۹۸/۱۰/۱۲
                            </div>
                            <div className="tableColumnItem">۹۸/۱۰/۱۲
                            </div>
                            <div className="tableColumnItem">۹۸/۱۰/۱۲
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">مبلغ کل</div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">کد تخفیف</div>
                            <div className="tableColumnItem">
                                DAS62
                            </div>
                            <div className="tableColumnItem">
                                DAS62
                            </div>
                            <div className="tableColumnItem">
                                DAS62
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">مبلغ تخفیف</div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">مبلغ پرداخت شده</div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                            <div className="tableColumnItem">
                            <span className="forFlex">
                                ۲۵۰,۰۰۰
                                <p className="font-size_12 lightFont">تومان</p>
                            </span>
                            </div>
                        </div>
                        <div className="tableItem">
                            <div className="tableColumnItem">شماره پیگیری</div>
                            <div className="tableColumnItem">
                                #4873467567235472
                            </div>
                            <div className="tableColumnItem">
                                #4873467567235472
                            </div>
                            <div className="tableColumnItem">
                                #4873467567235472
                            </div>
                        </div>
                        <div className="tableItem textInLeft">
                            <div className="tableColumnItem emptyCell">
                                null
                            </div>
                            <div className="tableColumnItem">
                                <span className="icon icon-eraser"></span>
                            </div>
                            <div className="tableColumnItem">
                                <span className="icon icon-eraser"></span>
                            </div>
                            <div className="tableColumnItem">
                                <span className="icon icon-eraser"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagination organizer">
                    <div className="paginationItem">
                        <span className="icon icon-arrow-right font-size_14"></span>
                    </div>
                    <div className="paginationItem">
                        <span className="pageNumberBox">۱</span>
                    </div>
                    <div className="paginationItem">
                        <span className="pageNumberBox">۲</span>
                    </div>
                    <div className="paginationItem">
                        <span className="pageNumberBox">۳</span>
                    </div>
                    <div className="paginationItem">
                        <span className="icon icon-more"></span>
                    </div>
                    <div className="paginationItem">
                        <span className="pageNumberBox">۱۵</span>
                    </div>
                    <div className="paginationItem">
                        <span className="icon icon-more"></span>
                    </div>
                    <div className="paginationItem active">
                        <span className="pageNumberBox">۲۳</span>
                    </div>
                    <div className="paginationItem">
                        <span className="pageNumberBox">۲۴</span>
                    </div>
                    <div className="paginationItem">
                        <span className="icon icon-arrow-left font-size_14"></span>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Transactions;
